export default __webpack_public_path__ + "static/media/visionBox.582a7812.png";